<template>
  <div>
    <!-- {{JSON.stringify(arr2)}} -->
    <Select v-model="v1" filterable placeholder="类别" @on-change="selectChange" @on-clear>
      <Option v-for="item in type" :value="item.name" :key="item.name">{{ item.name }}</Option>
    </Select>
    <div class="select-group" v-if="type2 && type2.length">
      <Row v-for="(it, idx) in arr" :key="'select-group-' + idx">
        <Col span="11" class="select-sigle">
        <Select v-model="it.level2" filterable placeholder="一级类别" @on-change="selectChange2($event, idx)">
          <Option v-for="item2 in type2" :value="item2.name" :key="item2.name">{{ item2.name }}</Option>
        </Select>
        </Col>
        <Col span="11" class="select-sigle">
        <Select v-model="it.level3" filterable placeholder="二级类别" @on-change="selectChange3($event, idx)" multiple>
          <Option v-for="item3 in it.level3Arr" :value="item3.name" :key="item3.name">{{ item3.name }}</Option>
        </Select>
        </Col>
        <Col span="1" v-if="idx===0">
        <Icon type="ios-add-circle-outline" style="position: relative;top: 2px;font-size: 20px;cursor: pointer;color: #118eea;" @click="addGroup" />
        </Col>
        <Col span="1" v-else>
        <Icon type="ios-remove-circle-outline" style="position: relative;top: 2px;font-size: 20px;cursor: pointer;color: red;" @click="removeGroup(idx)" />
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "category-filed-type",
  model: {
    prop: "Modal",
    event: "sendModal",
  },
  props: {
    Modal: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  data() {
    return {
      AgentId: "cd4e8cef-c6f7-4e72-9132-93161b9e8c43",
      v1: null,
      type: null,
      type2: null,
      arr: [],
      arr2: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getCategoryByExhibitionList:
        "exhibitionModule/getCategoryByExhibitionList",
    }),
    async init() {
      let categoryData = await this.getCategoryByExhibitionList(
        this.exhibitionInfo.id
      );
      if (categoryData && categoryData.length) {
        this.type = categoryData;
      } else {
        this.type = [];
      }
      const copyData = JSON.parse(JSON.stringify(this.Modal));
      if (this.Modal) {
        if (this.Modal[0] && !this.Modal[0].agentId) {
          this.arr = [];
          this.v1 = this.Modal[0].Name;
          this.type.forEach((c) => {
            if (c.id === this.Modal[0].Id) {
              let copyData1 = JSON.parse(JSON.stringify(c));
              copyData1.list = [];
              this.arr2 = copyData1;
              let list = this.Modal[0].List;
              c.list.forEach((v) => {
                this.type2 = c.list;
                list.forEach((z, i) => {
                  let cur = null;
                  if (z.Id === v.id) {
                    cur = { level2: v.name, level3: [], level3Arr: v.list };

                    let copyData2 = JSON.parse(JSON.stringify(v));
                    copyData2.list = [];
                    this.arr2.list[i] = copyData2;
                  }
                  if (z.Id === v.id && v.list.length > 0 && z.List.length > 0) {
                    let level3Arr = [];
                    v.list.forEach((j) => {
                      z.List.forEach((w) => {
                        if (w.Id === j.id) {
                          if (level3Arr.indexOf(j.name) === -1) {
                            level3Arr.push(j.name);
                            let copyData3 = JSON.parse(JSON.stringify(j));
                            copyData3.list = [];
                            this.arr2.list[i].list.push(copyData3);
                          }
                        }
                      });
                    });
                    if (level3Arr.length) cur.level3 = level3Arr;
                  }
                  if (cur) {
                    this.arr.push(cur);
                  }
                });
              });
            }
          });
        }
      }
      if (this.arr.length === 0) {
        this.arr = [{ level2: null, level3: [], level3Arr: [] }];
      }
    },
    send() {
      let copyData = JSON.parse(JSON.stringify(this.arr2));
      this.$emit("sendModal", [copyData]);
    },
    selectChange(e) {
      let value1 = null;
      if (this.type && this.type.length) {
        this.type.forEach((c) => {
          if (c.name === e) {
            value1 = JSON.parse(JSON.stringify(c));
            value1.list = [];
          }
          if (c.name === e && c.list && c.list.length) {
            this.type2 = c.list;
          }
        });
      }
      this.arr2 = value1;
      this.arr = [{ level2: null, level3: [], level3Arr: [] }];
      this.send();
    },
    selectChange2(e, idx) {
      if (!e) return;
      let value2 = null;
      if (this.type2 && this.type2.length) {
        this.type2.forEach((c) => {
          if (c.name === e) {
            value2 = JSON.parse(JSON.stringify(c));
            value2.list = [];
          }
          if (c.name === e && c.list && c.list.length) {
            this.arr[idx].level3Arr = c.list;
            this.type3 = c.list;
          }
        });
      }
      this.arr2.list[idx] = value2;
      if (this.arr2.list[idx]) {
        this.arr2.list[idx].list = [];
      }

      this.send();
    },
    selectChange3(e, idx) {
      if (!e || !e.length) return;
      let value3 = [];
      let type = this.arr[idx].level3Arr;
      if (type && type.length) {
        type.forEach((c) => {
          if (e.indexOf(c.name) !== -1) {
            value3.push(c);
          }
        });
      }

      this.arr2.list[idx].list = value3;
      this.send();
    },
    close() {
      this.v1 = null;
      this.type2 = null;
      this.arr = [];
      this.arr2 = null;
    },
    addGroup() {
      this.arr.push({ level2: null, level3: null, level3Arr: [] });
    },
    removeGroup(idx) {
      this.arr.splice(idx, 1);
      this.arr2.list.splice(idx, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.select-group {
  .ivu-row {
    margin-top: 10px;
  }
  .select-sigle {
    padding-right: 10px;
  }
}
</style>

